// В.2.c: Инъекция адреналина (liv_inektsiya_adrenalina, common Действие, Лив Лайф).
// «Даёт юниту +2 к Атаке до конца следующего хода и лечит его на 1 ХП».
//
// Picker: только СВОИ юниты на поле. Если своих нет — сгорает.
//
// Эффект:
//   1) applyTemporaryBuff(target, {atk:2}, expiresAtTurn = currentTurn + 2).
//      «До конца следующего хода» = бафф активен в текущем ходу N (Ф3) и в
//      ходу N+1, снимается в Ф1 хода N+2 утилитой expireTemporaryBuffs.
//      Это правило согласовано с диздоком: ход разыгрывания + следующий ход
//      целиком, истечение в начале хода после следующего.
//   2) healUnit(target, 1) — постоянный +1 ХП. Это НЕ временный hp-buff.
//      Если цель на полном ХП — actualAmount=0, событие healed не эмитится.

import { applyTemporaryBuff } from '../../buffs.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_inektsiya_adrenalina';
const LABEL = 'Инъекция адреналина';

registerImplementedAbility(CARD_ID, 'oneshot');

export function actionTargets(state, playerIdx) {
  const me = state.players?.[playerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u => u.type === 'unit');
}

export function resolve(state, playerIdx, target /*, opts */) {
  const me = state.players?.[playerIdx];
  const ownUnits = me ? me.unitsOnField().filter(u => u.type === 'unit') : [];
  if (ownUnits.length === 0) {
    state.log?.add(`📋 ${LABEL}: нет цели — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  if (!target || !target.isAlive || !target.isAlive() ||
      target.type !== 'unit' || target.ownerId !== playerIdx) {
    state.log?.add(`📋 ${LABEL}: цель недоступна — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  const expiresAtTurn = state.currentTurn + 2;
  applyTemporaryBuff(state, target, { atk: 2 }, expiresAtTurn, CARD_ID, LABEL);
  healUnit(state, target, 1, { id: CARD_ID, name_ru: LABEL, type: 'action' });
  state.log?.add(
    `📋 ${LABEL} → ${target.name_ru} [${me.name}]: +2/0/0 до начала хода ${expiresAtTurn}, +1 ХП`
  );
  return { ok: true };
}
